import {query} from 'api';
import PropTypes from 'prop-types';
import RecipeCircle from './recipeCircle';
import {Container, Slides} from './styles';
import {MainTitleDark, SmallTitle} from 'ui';
import {Circle, Img, Mask, Label} from './recipeCircle/styles';
import allRecipes from 'assets/img/allRecipes.png';
import {useDragDetection} from 'lib/slider';

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  variableWidth: true,
  slidesToScroll: 3,
};

const RecipeCircleList = ({data, setSelectedCategory, selectedCategory}) => {
  const {handleMouseDown, dragging} = useDragDetection();

  function handleChildClick() {
    if (!dragging) {
      setSelectedCategory(null);
    }
  }

  if (!data) return null;
  // Literally the same thing is done on BE
  data.map((element, index) => {
    if (element.name === 'Vidéos') {
      data.splice(index, 1);
      data.unshift(element);
    }
    return data;
  });

  const isAllCategory = selectedCategory === null;

  return (
    <Container className="recipeCircleList">
      {/* {console.log(data)} */}
      <SmallTitle>tous les desserts et toutes les envies</SmallTitle>
      <MainTitleDark>Toutes nos recettes</MainTitleDark>
      <Slides {...settings}>
        <Circle onMouseDownCapture={handleMouseDown} onClickCapture={handleChildClick}>
          <Mask selected={isAllCategory} style={{marginLeft: isAllCategory ? -5 : null}}>
            <Img
              src={allRecipes}
              placeholder={false}
              placeholderStyle={{backgroundColor: 'transparent'}}
            />
          </Mask>
          <Label selected={isAllCategory}>Toutes les recettes</Label>
          {/* <div>{`/wp/v2/recette_club?per_page=4&categories=${data.id}`}</div> */}
        </Circle>
        {data.map(categoryData => (
          <RecipeCircle
            key={categoryData.id}
            data={categoryData}
            onClick={() => setSelectedCategory(categoryData.id)}
            selected={selectedCategory === categoryData.id}
          />
        ))}
      </Slides>
    </Container>
  );
};

RecipeCircleList.propTypes = {
  data: PropTypes.array,
  selectedCategory: PropTypes.number,
  setSelectedCategory: PropTypes.func.isRequired,
};

export default RecipeCircleList |> query('getCircleRecipeList');
